import { call, put, takeEvery } from 'redux-saga/effects';
import apiSaga, { apiActionSagaTemplate } from './apiSaga';
import { isEmpty } from 'lodash';
import { HIDE_TAGS, GET_HIDDEN_TAGS, DELETE_HIDDEN_TAG } from 'actionTypes';
import { parseHiddenTags } from 'services/recommendationParamsService';

import {
  getHiddenTags,
  getHiddenTagsSuccess,
  getDefaultRecommendations,
  getFilteredRecommendations,
} from 'actions';

const hiddenTagsSaga = apiActionSagaTemplate(getHiddenTagsSuccess);

function* hideTagsSaga(action) {
  const hiddenTags = parseHiddenTags(action.hiddenTags);
  let response = yield call(apiSaga, action, hiddenTags);
  if (isEmpty(response.errors)) {
    yield put(getDefaultRecommendations());
  }
}
function* deleteHiddenTagSaga(action) {
  let response = yield call(apiSaga, action, action.payload);
  if (isEmpty(response.errors)) {
    yield put(getHiddenTags());
    yield put(getFilteredRecommendations({ isHidden: true }));
  }
}

export default [
  takeEvery(HIDE_TAGS, hideTagsSaga),
  takeEvery(GET_HIDDEN_TAGS, hiddenTagsSaga),
  takeEvery(DELETE_HIDDEN_TAG, deleteHiddenTagSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/hiddenTagSagas.js